import { Injectable } from '@angular/core'
import { WebService } from '../api/web.service'
import { Observable } from 'rxjs'
import { ServiceUrlConstants } from '../../constants/service-url-constants'

@Injectable({
  providedIn: 'root'
})
export class OptionsService {
  constructor(private webService: WebService) {}

  getOptionsForType(typeArr: string[]): Observable<any> {
    return this.webService.post(ServiceUrlConstants.API_OPTIONS, typeArr)
  }
}
